import css from "styled-jsx/css";
import { PAYMENT_METHOD_SERVICES } from "utils/constants/payment";

export const styles = css`
  :global(.paymentMethod--${PAYMENT_METHOD_SERVICES.APPLE}::after) {
    background-image: url("/assets/paymentMethod--${PAYMENT_METHOD_SERVICES.APPLE}.svg");
  }
  :global(.paymentMethod--${PAYMENT_METHOD_SERVICES.GOOGLE}::after) {
    background-image: url("/assets/paymentMethod--${PAYMENT_METHOD_SERVICES.GOOGLE}.svg");
  }
`;
